import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { useExtrasFormContext } from './useExtrasFormContext';
import { useExtrasSchema } from './useExtrasSchema';

export function useAncillariesFromFormData() {
	const newBookingStore = useNewBookingStore();
	const { watch } = useExtrasFormContext();

	const data = watch();

	// Sanitize raw form data using the schema
	const schema = useExtrasSchema();
	const ancillaryGroupSelection = schema.cast(data)?.ancillaryGroups ?? [];

	const ancillaries = newBookingStore.getAncillariesForSelections(
		ancillaryGroupSelection,
	);

	return ancillaries;
}
